import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "@/shared/ui/ui";

export interface ArchiveProductDialogProps {
  /** El producto a archivar, o `null` cuando no hay nada que confirmar. */
  productName: string | null;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

/**
 * La confirmación antes de archivar.
 *
 * Existe porque archivar es una acción que cambia lo que ve el público y
 * que se dispara desde un icono pequeño en una fila entre veinticuatro:
 * el clic equivocado es cuestión de tiempo.
 *
 * El texto dice explícitamente que NO se borra. Sin esa frase, "archivar"
 * se lee como "eliminar" y quien administra evita usarlo, que es peor:
 * acaba dejando productos muertos publicados.
 */
export function ArchiveProductDialog({
  productName,
  onConfirm,
  onCancel,
  loading = false,
}: ArchiveProductDialogProps) {
  const { t } = useTranslation();

  if (productName === null) return null;

  return (
    <ConfirmDialog
      open
      variant="warning"
      title={t("¿Archivar este producto?")}
      description={t(
        "«{{name}}» dejará de verse en la tienda. No se borra: los pedidos que ya lo incluyen lo siguen encontrando.",
        { name: productName },
      )}
      confirmLabel="Archivar"
      cancelLabel="Cancelar"
      loading={loading}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
